import { STUDIO_EMAIL } from '@/constants/studio'

export interface Award {
    year: number
    name: string
    result: string
    project: string
    href: string
    note: string
}

export const AWARDS: Array<Award> = [
    {
        year: 2025,
        name: 'Baltic Culture Shortlist',
        result: 'Shortlisted',
        project: 'Ostra Cultural Hall',
        href: '/projects/ostra-cultural-hall',
        note: 'Cited for the steel truss and for redesigning a door from occupancy data in the first season.'
    },
    {
        year: 2024,
        name: 'Nordic Timber Prize',
        result: 'Winner',
        project: 'Hallmark Library',
        href: '/projects/hallmark-library',
        note: 'Awarded for the stepped CLT roof over three storeys and a scan-checked frame that opened on time.'
    },
    {
        year: 2023,
        name: 'Iberian Housing Prize',
        result: 'Winner',
        project: 'Casa Mares',
        href: '/projects/casa-mares',
        note: 'Awarded for 64 cooperative homes whose facade fins were redrawn from the thermal model.'
    }
]

export interface PressItem {
    outlet: string
    date: string
    headline: string
    href: string
}

export const PRESS: Array<PressItem> = [
    { outlet: 'Timber Review North', date: '2026-04-14', headline: 'A gridshell over four platforms: the Vantaa roof takes shape', href: '/projects/vantaa-station-roof' },
    { outlet: 'Form and Fabric', date: '2025-11-04', headline: 'The library that measured its own floors before anyone walked on them', href: '/projects/hallmark-library' },
    { outlet: "The Surveyor's Quarterly", date: '2025-06-20', headline: 'Two millimetres at ten metres: a day with a Norrvik scan crew', href: '/platform#capture' },
    { outlet: 'Timber Review North', date: '2024-12-02', headline: 'Why civic buildings in the north should start with timber', href: '/materials#timber' },
    { outlet: 'Form and Fabric', date: '2024-03-18', headline: 'Casa Mares, the housing block that answers back', href: '/projects/casa-mares' },
    { outlet: "The Surveyor's Quarterly", date: '2023-09-11', headline: 'When the as-built disagrees with the drawing, believe the scan', href: '/field-reports' }
]

export const PUBLICATIONS = {
    labels: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'],
    values: [2, 3, 3, 4, 6, 5, 8, 9, 11]
}

export interface MediaItem {
    label: string
    detail: string
    format: string
    href: string
}

export const MEDIA: Array<MediaItem> = [
    { label: 'Press kit', detail: 'Studio facts, partner portraits, wordmark and point-cloud stills', format: 'On request', href: `mailto:${STUDIO_EMAIL}?subject=${encodeURIComponent('Press kit request')}` },
    { label: 'Project sheet / Hallmark Library', detail: 'Facts, drawings, energy and lessons', format: 'Online', href: '/projects/hallmark-library' },
    { label: 'Project sheet / Casa Mares', detail: 'Facts, drawings, energy and lessons', format: 'Online', href: '/projects/casa-mares' },
    { label: 'Project sheet / Ostra Cultural Hall', detail: 'Facts, drawings, energy and lessons', format: 'Online', href: '/projects/ostra-cultural-hall' },
    { label: 'Project sheet / Kelda Bath House', detail: 'Facts, drawings, energy and lessons', format: 'Online', href: '/projects/kelda-bath-house' },
    { label: 'Project sheet / Ribeira Bridge Pavilion', detail: 'Facts, drawings, energy and lessons', format: 'Online', href: '/projects/ribeira-bridge-pavilion' },
    { label: 'Project sheet / Vantaa Station Roof', detail: 'Facts, drawings and build progress', format: 'Online', href: '/projects/vantaa-station-roof' },
    { label: 'Image requests', detail: 'Scan imagery by Norrvik, cleared for editorial use', format: 'On request', href: `mailto:${STUDIO_EMAIL}?subject=${encodeURIComponent('Image request')}` }
]
